import { paths } from '../routes/paths';
import { buildEmergencyFundAlerts, EF_ALERT_TYPES } from './buildEmergencyFundAlerts';

/** Tipos de alerta do dashboard (extensível). */
export const DASHBOARD_ALERT_TYPES = {
  MISSING_BUDGETS_SUMMARY: 'missing_budgets_summary',
  CATEGORY_BUDGET_EXCEEDED_SUMMARY: 'category_budget_exceeded_summary',
  METHOD_ALLOCATION_OVER: 'method_allocation_over',
  ...EF_ALERT_TYPES,
};

export function flattenOverviewCategories(overview) {
  return (overview?.groups || []).flatMap((group) => group.categories || []);
}

/**
 * @param {object|null} overview
 * @param {{ hasIncome?: boolean, hasSnapshots?: boolean, maxItems?: number, budgetAlerts?: object[] }} [context]
 */
export function buildDashboardAlerts(overview, context = {}) {
  const {
    hasIncome = false,
    hasSnapshots = false,
    maxItems = 8,
    efApiAlerts = [],
    budgetAlerts = [],
  } = context;

  const alerts = [...buildEmergencyFundAlerts(efApiAlerts)];

  if (budgetAlerts.length > 0) {
    alerts.push({
      id: 'category-budget-exceeded-summary',
      type: DASHBOARD_ALERT_TYPES.CATEGORY_BUDGET_EXCEEDED_SUMMARY,
      href: paths.expenses,
      meta: {
        count: budgetAlerts.length,
        alertIds: budgetAlerts.map((a) => a.id),
      },
    });
  }

  if (!overview) return alerts.slice(0, maxItems);

  const missingCount = flattenOverviewCategories(overview).filter(
    (c) => c.status === 'no_budget',
  ).length;
  if (missingCount > 0) {
    alerts.push({
      id: 'missing-budgets-summary',
      type: DASHBOARD_ALERT_TYPES.MISSING_BUDGETS_SUMMARY,
      href: paths.expenses,
      meta: { count: missingCount },
    });
  }

  if (hasIncome && hasSnapshots && overview.method) {
    (overview.groups || [])
      .filter((g) => g.alignment_status === 'over' && g.name)
      .forEach((group) => {
        alerts.push({
          id: `method-over-${group.id || group.name}`,
          type: DASHBOARD_ALERT_TYPES.METHOD_ALLOCATION_OVER,
          href: paths.budget,
          meta: {
            groupName: group.name,
            targetPct:
              group.target_pct != null ? Number(group.target_pct) : null,
            alignmentPct:
              group.alignment_pct != null ? Number(group.alignment_pct) : null,
          },
        });
      });
  }

  return alerts.slice(0, maxItems);
}

/** Tom semântico (`ds/alerts/item--*` no .pen) para cada tipo de alerta. */
export function classifyAlertSeverity(alert) {
  switch (alert?.type) {
    case DASHBOARD_ALERT_TYPES.CATEGORY_BUDGET_EXCEEDED_SUMMARY:
    case DASHBOARD_ALERT_TYPES.METHOD_ALLOCATION_OVER:
    case EF_ALERT_TYPES.EXPENSES_ABOVE_TARGET:
    case EF_ALERT_TYPES.BELOW_TARGET:
      return 'warning';
    default:
      return 'info';
  }
}

